import { AccessorialButton } from './Accesorials.styled';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { AccessorialsColumnsProps } from '../../../pages/get-quote/models';
import AccessorialsModal from '../../AccessorialsModal';
import { UserModel } from '../../../modules/auth/models/UserModel';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';

const AccessorialsColumns = ({accessorials, handleDelete, selectAcc, accessorialType, selectedAcc, openAccModal, setOpenAccModal, setAccessorial, setSearchAccessorials, setOpenInsuranceModal, formikValues, setOpenClearRateToEditModal, setOpen, forDefaults, formDisabled, setAccessorialSelected, setOpenInsurancePromptModal}: AccessorialsColumnsProps) => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

    return (
        <>
            <div className="col-12 col-sm-4 ps-0 mb-5 mb-sm-0" id='fieldAccessorials'>
                <div className="col-12 col-form-label ps-5 pt-5" id='fieldAccessorials'>{accessorialType}</div>
                {
                    accessorials?.filter(acc => acc.category === accessorialType).length === 0
                    && <div style={{padding: '5.2px 0px 5.2px 16.25px', color: "#a1a5b6"}} id='fieldAccessorials'>No accessorials</div>
                }
                {accessorials?.map((accessorial, index) => {
                    return (
                        accessorial.category === accessorialType && (
                            <AccessorialButton
                                id='fieldAccessorials'
                                key={index}
                                onClick={() => {
                                    if((formikValues && formikValues?.carrierInformation?.name) || formDisabled){
                                        setOpenClearRateToEditModal(true)
                                        setOpen(false)
                                    }else{
                                        if((accessorial?.code === 'INS' || accessorial?.code === 'DV') && !forDefaults){
                                            if(user?.insurancePrompt){
                                                setOpenInsurancePromptModal(true)
                                            }else{
                                                setOpenInsuranceModal(true)
                                            }
                                            setAccessorialSelected(accessorial)
                                        }else if(accessorial?.code === 'VINS' || accessorial?.code === 'COD' || accessorial?.code === 'FCCOD'  || accessorial?.code === 'ArtSkh02' || accessorial?.code === 'ArtSkh04'){
                                            setOpenInsuranceModal(true)
                                            setAccessorialSelected(accessorial)
                                        }

                                        setSearchAccessorials('')
                                        const accValueRequired = accessorial?.valueRequired
                                        if(accValueRequired?.required){
                                            setAccessorial(accessorial)
                                            setOpenAccModal(true)
                                        }
                                        selectAcc(accessorial)
                                    }
                                }}
                                disabled={selectedAcc?.filter(acc => acc.id === accessorial.id).length > 0}
                                isSelected={selectedAcc?.filter(acc => acc.id === accessorial.id).length > 0}
                            >
                                <div className="row align-items-center" id='fieldAccessorials'>
                                    <div className="col-10 col-sm-9" id='fieldAccessorials'>
                                        {accessorial.nameShort}
                                    </div>
                                    {selectedAcc?.filter(acc => acc.id === accessorial.id).length > 0 &&
                                        <div className="col-2 col-sm-2 justify-content-end" id='fieldAccessorials'>
                                            <IconButton className="p-0" id='fieldAccessorials' onClick={() => {
                                                handleDelete(accessorial)
                                            }}>
                                                <ClearIcon id='fieldAccessorials' fontSize="small"/>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <AccessorialsModal
                                    open={openAccModal}
                                    setOpen={setOpenAccModal}
                                    data={accessorial?.valueRequired}
                                />
                            </AccessorialButton>
                        )
                        
                    );
                })}
            </div>
        </>
    )
}

export default AccessorialsColumns